// extracted by mini-css-extract-plugin
export default {"text":"DynamicFakedoorModal__text--3DDUI"};